<template>
  <div>
    <el-dialog :title="title" :visible.sync="addDialogVisible" class="imgbox" width="50%" :before-close="resetForm"
      :append-to-body="true" :close-on-click-modal="false">
      <el-form :disabled="propData.status === 1" resetFields label-width="100px" ref="ruleForm" :rules="rules"
        :model="form">
        <el-form-item label="品类序列号" prop="categoryNumber">
          <el-input maxlength="20" onKeypress="return (/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
            v-model.number="form.categoryNumber" autocomplete="off" type="number" placeholder="请输入品类序列号"
            :disabled="propData.status === 2"></el-input>
        </el-form-item>
        <el-form-item label="品类名称" prop="categoryName">
          <el-input maxlength="20" v-model.trim="form.categoryName" autocomplete="off" placeholder="请输入品类名称"></el-input>
        </el-form-item>
        <el-form-item label="语言">
          <el-input maxlength="20" disabled v-model="languageShow" autocomplete="off" placeholder="请输入品类名称"></el-input>
        </el-form-item>
        <el-form-item v-if="type != 'second'" label="所属品类" :required="true">
          <el-input :disabled="true" v-model.trim="belongCategory" autocomplete="off" placeholder="请输入品类名称">
            <i class="el-icon-arrow-down el-input__icon" slot="suffix">
            </i>
          </el-input>
        </el-form-item>
        <el-form-item v-if="type != 'second'" label="品类图片">
          <el-row type="flex">
            <!-- 高亮 -->
            <el-col class="fileuploadItem gavin" :span="5">
              <el-upload :data="data" :show-file-list="false"
                :on-success="(res, file) => { handleAvatarSuccess(0, res, file) }" :before-upload="beforeUp"
                :on-remove="handleRemove" class="avatar-uploader"
                action="/api/paas-platform/file-service/v1/file/upload/fileUpload" accept="image/png">
                <img v-if="fileList[0].fileUrl !== ''" :src="fileList[0].fileUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon" />
              </el-upload>
              <span class="file_upload_img_des">高亮状态</span>
            </el-col>

            <!-- 默认状态小尺寸 -->
            <el-col class="fileuploadItem gavin" :offset="1" :span="5">
              <el-upload :data="data" :show-file-list="false"
                :on-success="(res, file) => { handleAvatarSuccess(1, res, file) }" :before-upload="beforeUp"
                :on-remove="handleRemove" class="avatar-uploader"
                action="/api/paas-platform/file-service/v1/file/upload/fileUpload" accept="image/png">
                <img v-if="fileList[1].fileUrl !== ''" :src="fileList[1].fileUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon" />
              </el-upload>
              <span class="file_upload_img_des">默认状态小尺寸</span>
            </el-col>
            <!-- 默认状态大尺寸 -->
            <el-col class="fileuploadItem gavin" :offset="1" :span="5">
              <el-upload :data="data" :show-file-list="false"
                :on-success="(res, file) => { handleAvatarSuccess(2, res, file) }" :before-upload="beforeUp"
                :on-remove="handleRemove" class="avatar-uploader"
                action="/api/paas-platform/file-service/v1/file/upload/fileUpload" accept="image/png">
                <img v-if="fileList[2].fileUrl !== ''" :src="fileList[2].fileUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon" />
              </el-upload>
              <span class="file_upload_img_des">默认状态大尺寸</span>
            </el-col>
            <!-- 不可用 -->
            <el-col class="fileuploadItem gavin" :offset="1">
              <el-upload :data="data" :show-file-list="false"
                :on-success="(res, file) => { handleAvatarSuccess(3, res, file) }" :before-upload="beforeUp"
                :on-remove="handleRemove" class="avatar-uploader"
                action="/api/paas-platform/file-service/v1/file/upload/fileUpload" accept="image/png">
                <img v-if="fileList[3].fileUrl !== ''" :src="fileList[3].fileUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon" />
              </el-upload>
              <span class="file_upload_img_des">不可用状态</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="物模型类型" prop="modelType" v-if="propData.status === 0 && type != 'second'">
          <el-radio-group v-model="form.modelType">
            <el-radio :label="0">自定义物模型</el-radio>
            <el-radio :label="1">导入物模型</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择文件" prop="snUrl" v-if="form.modelType === 1">
          <el-upload ref="upload" name="file" action="bb" :auto-upload="false" :on-change="handleChange" accept=".json"
            :file-list="jsonFileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">{{ propData.status !== 1 ? '取 消' : '关 闭' }}</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-if="propData.status !== 1">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addSubCategory, editSubCategory, detailSubCategory } from '@/api/categoryManager'
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object
    },
    category: {
      type: Object
    },
    type: {
      type: String
    },
    dialogTitle: {
      type: String
    }
  },
  data() {
    /* const urlVerti = (rule, value, callback) => {
      if (this.fileList.length < 1) {
        callback(new Error('至少上传一张图片'))
      } else {
        callback()
      }
    } */
    /* const categoryNum = (rule, value, callback) => {
      const reg = /[0-9]/
      if (this.form.modelType === '') {
        callback(new Error('品类序列号不能为空!'))
      } else if (!reg.test(this.form.modelType)) {
        callback(new Error('品类序列号格式错误!'))
      } else {
        callback()
      }
    } */
    const fileNumber = (rule, value, callback) => {
      console.log(this.$refs.upload)
      console.log(this.jsonFileList)
      if (this.jsonFileList.length < 1) {
        callback(new Error('请选择文件！'))
      } else {
        callback()
      }
    }
    const nameValidate = (rule, value, callback) => {
      if (value.length > 20) {
        callback(new Error('请输入二十个字符以内的名称'))
      } else {
        callback()
      }
    }
    return {
      title: '',
      data: {
        dir: 'category/subCategory/img'
      },
      token: localStorage.getItem('authorization'),
      jsonFileList: [],
      fileList: [
        {
          fileKey: '',
          fileUrl: '',
          fileDesc: 'highLight',
          fileName: ''
        },
        {
          fileKey: '',
          fileUrl: '',
          fileDesc: 'normalSmall',
          fileName: ''
        },
        {
          fileKey: '',
          fileUrl: '',
          fileDesc: 'normalBig',
          fileName: ''
        },
        {
          fileKey: '',
          fileUrl: '',
          fileDesc: 'disabled',
          fileName: ''
        }
      ],
      jsonObject: null,
      form: {
        categoryNumber: '',
        categoryName: '',
        modelType: 0
      },
      highLightUrl: '', // 测试
      normalBigUrl: '',
      normalSmallUrl: '',
      disabledUrl: '',
      belongCategory: '', // 品类名称
      rules: {
        modelType: [
          { required: true, message: '请选择模板类型', trigger: 'change' }
        ],
        categoryNumber: [
          { required: true, message: '品类序列号不能为空', trigger: 'blur' }
        ],
        categoryName: [
          { required: true, message: '品类名称不能为空', trigger: 'blur' },
          { validator: nameValidate, trigger: 'blur' }
        ],
        /* fileLists: [
          { required: true, validator: urlVerti, trigger: 'change' }
        ], */
        snUrl: [
          { required: true, validator: fileNumber, trigger: 'change' }
        ]
      }
    }
  },
  created() {


    if (this.category) {
      this.belongCategory = this.category.categoryName;
      this.form.language = this.category.language;
    }
    if (this.propData.status !== 0) {
      const params = {
        categoryId: this.propData.categoryId
      }
      detailSubCategory({ params }).then((res) => {
        console.log(res.data.data)
        this.$nextTick(() => {
          this.form.categoryNumber = res.data.data.categoryNumber
          this.form.categoryName = res.data.data.categoryName
          console.log('我是返回来的', res.data.data.fileList)
          if (JSON.stringify(res.data.data.fileList) !== 'null' && res.data.data.fileList.length !== 0) {
            res.data.data.fileList.forEach((e, index) => {
              this.fileList.forEach((ele, i) => {
                if (e.fileDesc === ele.fileDesc) {
                  ele.fileKey = e.fileKey
                  ele.fileUrl = e.fileUrl
                  ele.fileName = e.fileName;
                }
              })
            })
            console.log('我是已经有的', this.fileList)
          }
        })
      })
    }
    this.getTitle()
  },
  methods: {
    getTitle() {
      let title = '';
      let { status } = this.propData.status;
      if (status === 0) {
        title = '新增'
      } else if (status === 2) {
        title = '编辑品类'
      } else {
        title = '查看'
      }
      this.title = title + this.dialogTitle;
    },
    // 上传图片
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handleAvatarSuccess(obj, res, file) {
      // console.log(obj, res, file)
      if (res.code !== 200) {
        this.$message.error('上传出错，请重新上传')
        return
      }
      this.fileList[obj].fileUrl = res.data.fileUrl
      this.fileList[obj].fileKey = res.data.pathKey
      this.fileList[obj].fileName = file.name
      /* switch (obj) {
        case 0:
          this.fileList[obj].fileDesc = 'highLight'
          break
        case 1:
          this.fileList[obj].fileDesc = 'normalSmall'
          break
        case 2:
          this.fileList[obj].fileDesc = 'normalBig'
          break
        case 3:
          this.fileList[obj].fileDesc = 'disabled'
          break
      } */
    },
    beforeUp(file) {
      const reader = new FileReader()
      reader.onload = function (event) {
        const txt = event.target.result
        const img = document.createElement('img')
        img.src = txt
        img.onload = function () {
          /* console.log(img.width)
          console.log(img.height) */
        }
      }
      reader.readAsDataURL(file)
    },
    submitForm() {
      /* if (this.$refs.ruleForm.validateField('fileList')) {
        return false
      } */
      let x = this.form;
      
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.form.modelType === 1) {
            this.form.jsonObject = this.jsonObject
          }
          this.form.categoryId = this.propData.categoryId
          const list = this.fileList.filter((e) => {
            console.log(e)
            return e.fileKey !== ''
          })
          this.form.fileList = list
          if (this.propData.status) {
            const params = Object.assign({}, this.form)
            editSubCategory({ params }).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '编辑完成'
                })
                this.$emit('closeAddDialog', { status: 'refresh', type: 'subCategoryDialog' })
              }
            })
          } else {
            this.form.categoryParentId = this.category.categoryId
            const params = Object.assign({}, this.form)
            
            addSubCategory({ params }).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.$emit('closeAddDialog', { status: 'refresh', type: 'addSubDialogVisible' })
              }
            })
          }
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$emit('closeAddDialog', { status: 'close', type: 'addSubDialogVisible' })
    },
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      const type = file.raw.type
      const ext = type.substring(type.lastIndexOf('.') + 1)
      if (ext !== 'application/json') {
        this.$message.error('请上传json文件格式')
        this.jsonFileList = []
        return
      }
      const files = fileList[0]
      this.jsonFileList = fileList
      console.log(this.jsonFileList)
      const reader = new FileReader()
      reader.readAsText(files.raw)
      reader.onload = (e) => {
        // 读取文件内容
        const fileString = e.target.result
        // 需要给其重新赋值否则转对象失败
        const strObj = fileString
        console.log(strObj)
        this.jsonObject = JSON.parse(strObj)
        console.log(this.jsonObject)
      }
    },
    beforeUpload(file) {
      const name = file.name
      const type = name.substring(name.lastIndexOf('.') + 1)
      debugger
      if (type !== 'json') {
        this.$message.error('请上传json文件格式')
        return false
      }
      if (file.size > 1024 * 1024) {
        this.$message.error('文件大小超过1M请重试')
        return false
      }
    }
  },
  computed: {
    languageShow() {
      return this.category.language === 0 ? '中文' : '英文'
    }
  }
}
</script>

<style lang='less' scoped>
.el-col-5 {
  text-align: center;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
}

/deep/.avatar-uploader {
  width: 100px;
  height: 100px;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
